<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Music Off" class="d-icon d-icon--music-off" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M10.823 1.119A.5.5 0 0 1 11 1.5V8c0 .053-.002.106-.006.158a.5.5 0 0 1-.997-.078 1 1 0 0 0-1.075-1.077.5.5 0 0 1-.076-.997A2.021 2.021 0 0 1 10 6.268V2.09l-5.092.848a.5.5 0 1 1-.165-.986l5.675-.946a.5.5 0 0 1 .405.112Zm-9.676.028a.5.5 0 0 1 .707 0l9 9a.5.5 0 1 1-.707.707l-.873-.872a2 2 0 0 1-2.256-2.255L5 5.706V9a2 2 0 1 1-1-1.732v-2.56L1.147 1.853a.5.5 0 0 1 0-.707ZM4 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMusicOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
